import axios from 'axios';
import createBasicAuthToken from './AuthenticationService';
const API_URL = process.env.REACT_APP_PROFILE === 'dev' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_PROFILE === 'uat' ? process.env.REACT_APP_API_URL_UAT : process.env.REACT_APP_API_URL_PROD;

interface SaveResult {
    custCode?: string | null,
    sresult?: string,
    surveyName?: string,
    bcustCode?: string | null
}

interface Login {
    username: string,
    password: string
}

const saveResult = (data: SaveResult) => {
    return axios.post(`${API_URL}/save_result`, data,
        {
            headers: {
                authorization: createBasicAuthToken(process.env.REACT_APP_BASIC_AUTH_USERNAME, process.env.REACT_APP_BASIC_AUTH_PASSWORD),
                "Content-Type": "application/json",
            }
        });
}

const getLang = (custCode?: string) => {
    return axios.get(`${API_URL}/get_lang?custCode=${custCode}`,
        {
            headers: {
                authorization: createBasicAuthToken(process.env.REACT_APP_BASIC_AUTH_USERNAME, process.env.REACT_APP_BASIC_AUTH_PASSWORD),
                "Content-Type": "application/json",
            }
        });
}

const login = (loginBody: Login) => {
    return axios.post(`${API_URL}/login`, loginBody,
        {
            headers: {
                authorization: createBasicAuthToken(process.env.REACT_APP_BASIC_AUTH_USERNAME, process.env.REACT_APP_BASIC_AUTH_PASSWORD),
                "Content-Type": "application/json",
            }
        });
}

const getResult = () => {
    return axios.get(`${API_URL}/get_result`,
        {
            headers: {
                authorization: createBasicAuthToken(process.env.REACT_APP_BASIC_AUTH_USERNAME, process.env.REACT_APP_BASIC_AUTH_PASSWORD),
                "Content-Type": "application/json",
            }
        });
}

export {
    saveResult,
    getLang,
    login,
    getResult
}